export enum IconSize {
  Normal = 'normal',
  Big = 'big',
}
